export default __webpack_public_path__ + "static/media/ALC_thumbnail.878b2c42.jpg";